export async function fetchTon(address) {
    const url = `https://tonapi.io/v2/blockchain/accounts/${address}/transactions`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${process.env.REACT_APP_TONAPI_KEY}` },
    });
    if (!res.ok) {
        return [];
    }

    const data = await res.json();
    const txs = Array.isArray(data?.transactions) ? data.transactions : [];

    const result = [];

    for (const tx of txs) {
        const time = Number(tx.utime);
        const hash = tx.hash;

        // ── Incoming message ────────────────────────────────
        const inMsg = tx.in_msg;
        if (inMsg && inMsg.source?.address && inMsg.destination?.address) {
            const val = String(inMsg.value ?? '0');
            if (val !== '0') {
                result.push({
                    timeSec: time,
                    valueRaw: val,
                    from: inMsg.source.address,
                    to: inMsg.destination.address,
                    network: 'TON',
                    meta: { hash },
                });
            }
        }

        // ── Outgoing messages ───────────────────────────────
        const outMsgs = Array.isArray(tx.out_msgs) ? tx.out_msgs : [];
        for (const msg of outMsgs) {
            if (!msg.source?.address || !msg.destination?.address) {
                continue;
            }
            const val = String(msg.value ?? '0');
            if (val === '0') {
                continue;
            }
            result.push({
                timeSec: time,
                valueRaw: val,
                from: msg.source.address,
                to: msg.destination.address,
                network: 'TON',
                meta: { hash },
            });
        }
    }

    return result;
}